<!--
  File: Coupon.vue
-->

<template>
  <v-container>
    <v-tabs v-model="tab" class="pa-0 mt--15" centered>
      <v-tab key="0" class="font-14" to="/">수업안내</v-tab>
      <v-tab key="1" class="font-14" to="/booking">수업예약</v-tab>
      <v-tab key="2" class="font-14">쿠폰정보</v-tab>
    </v-tabs>
    <v-spacer class="pb-6" />
    <v-row>
      <v-col cols="12" class="pa-3">
        <v-card outlined>
          <v-row class="ma-1">
            <v-col cols="3">쿠폰명</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">발행일</v-col>
            <v-col cols="5" md="3">유효기간</v-col>
            <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp">발행</v-col>
            <v-col cols="4" md="2">남은갯수</v-col>
          </v-row>
          <v-divider />
          <v-row :class="'ma-1 ' + color(coupon)" v-for="(coupon, i) in coupons" :key="i">
            <v-col cols="3">{{coupon.name}}</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">{{util.getDate(new Date(coupon.cdate))}}</v-col>
            <v-col cols="5" md="3">{{util.getDate(new Date(coupon.expired))}}</v-col>
            <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp">{{coupon.total}}</v-col>
            <v-col cols="4" md="2">{{coupon.remain}}</v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  name: 'Coupon',
  
  data () {
    return {
      tab: 2,
      login: null,
      edit: null,
      expire: null,
      remain: null,
      expires: [
        { value: 180, text: '6개월' },
        { value: 90, text: '3개월' },
        { value: 30, text: '1개월' },
        { value: 7, text: '1주일' },
        { value: 3, text: '3일' }
      ],
      remains: [
        { value: 30, text: '30개' },
        { value: 20, text: '20개' },
        { value: 10, text: '10개' },
        { value: 5, text: '5개' },
        { value: 0, text: '없음' }
      ],
      page: 1,
      pages: [],
      keyword: '',
      coupons: [],
      checked: false,
      user: {},
      util: util
    }
  },

  props: {
    source: String,
  },

  methods: {
    color: function(item) {
      return item.days < 0 || item.remain == 0 ? 'grey--text' : 'primary--text font-weight-bold'
    },

    refresh: function () {
      axios.get(`/api/coupon/user/${this.login.id}`)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else if (this.$vuetify.breakpoint.mdAndUp) {
          this.coupons = response.data.coupons
        }
        else if (response.data.coupons && response.data.coupons.length > 0) {
          this.coupons.push(response.data.coupons[0])
        }
      })
    },
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
    }
    if (this.login) {
      this.$emit('login', this.login)

      this.refresh()
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.mt--15 {
  margin-top: -15px;
}
.font-14 {
  font-size: 14px;
}
</style>